<template>
<div>
    <FeaturesSaveButton
        v-if='isSaveButtonShow'
        @click='setRecurrenceEndHandler'>
    </FeaturesSaveButton>

    <div class='b-form-recurrence'>
        <div class='h-text-center h-mv-20'>
            <div class='b-base-title h-mt-10 b-form-recurrence__title'>
                {{ $t('EVENT.RECURRENCE.END') }}
            </div>
        </div>
        <div>
            <FormMenuItem
                v-for='(item, index) in recurrenceEndFeatureList'
                :key='index'
                class='h-mv-10'
                :title='$t(item.title)'
                :isActive='index === activeIndex'
                leftIcon='reccurance-icon'
                @click='activeIndex = index'>
                <div v-if='item.id === validActiveIndex && activeIndex === validActiveIndex'
                     class='h-flex-center h-mb-10 h-mt-10'>
                    <FwDatepicker
                        :modelValue='localEndRecurrenceDate'
                        name='datepicker'
                        :placeholder='$t(`ADD.RESERVED.SLOT.FORM.RECURRENCE.CHOOSE_DAY.PLACEHOLDER`)'
                        :propsRange='false'
                        :selectMode='false'
                        pickerStyle='form'
                        :hideIcon='true'
                        :propsLang='`${$i18n.locale}`'
                        propsType='date'
                        propsFormat='DD/MM/YYYY'
                        :openOnTop='false'
                        :defaultValue='startDay'
                        :disabledDate='startEndRecurrenceDays'
                        propsInputClass='b-add-reserved-slot-form__datepicker'>
                        <template #icon>
                            &nbsp;
                        </template>
                    </FwDatepicker>
                </div>
            </FormMenuItem>
        </div>
        <div v-if='isRecurrenceYearly' class='h-flex-center b-add-edit__form__info h-mt-20'>
            <div>
                <FwIcon
                    class='h-mr-20 h-ml-20'
                    icon='alert-info'
                    size='23'
                    color='#bec7d3'>
                </FwIcon>
            </div>
            <div class='b-add-edit__form__info__text'>
                {{ $t('EVENT.FORM.YEARLY.INFO.ALERT') }}
            </div>
        </div>
    </div>
</div>
</template>

<script lang='ts'>
import { Component, Emit, mixins, Prop, Vue } from 'vue-facing-decorator';
import { FormItemChoosedEventType } from '@/types/Events/Base';
import { FormMenuItem } from '@/components/simple/FormMenuItem';
import { FeaturesSaveButton } from '@/components/forms/features/FeaturesSaveButton';
import { YEARLY } from '@/helpers/recurrence';

@Component({
    components: {
        FormMenuItem,
        FeaturesSaveButton,
    },
})
export default class RecurrenceEndFeature extends Vue {
    @Prop({ type: Date, default: null }) readonly endRecurrenceDate!: Date | null;
    @Prop({ type: Object, default: null }) readonly recurrence!: FormItemChoosedEventType | null;

    localEndRecurrenceDate: Date | null = null;
    startDay: Date | null = null;
    activeIndex: Number = 0;
    isSaveButtonShow: boolean = true;
    recurrenceEndFeatureList: Array<FormItemChoosedEventType> = [];

    get startEndRecurrenceDays() {
        return this.isRecurrenceYearly ? this.disableEndRecurrenceDays : this.disabledDateByObjectStartDay;
    }

    get disableEndRecurrenceDays() {
        const startDate = new Date();
        const endDate = new Date(startDate.getTime());
        endDate.setFullYear(endDate.getFullYear() + 3);
        return {
            disablePrevDays: startDate,
            disableNextDays: endDate,
        };
    }

    get disabledDateByObjectStartDay() {
        return {
            disablePrevDays: new Date() || null,
        };
    }

    get validActiveIndex() {
        return this.isRecurrenceYearly ? 0 : 1;
    }

    get isRecurrenceYearly() {
        return this.recurrence && this.recurrence.value && this.recurrence.value === YEARLY;
    }

    created() {
        this.localEndRecurrenceDate = this.endRecurrenceDate;
        this.recurrenceEndFeatureList = [{
            value: false,
            title: 'EVENT.RECURRENCE.PERSONALIZE',
            id: this.validActiveIndex,
        }];
        this.startDay = new Date();
        if (!this.isRecurrenceYearly) {
            this.recurrenceEndFeatureList.unshift({
                value: false,
                title: 'EVENT.RECURRENCE.NEVER',
                id: 0,
            });
        } else {
            this.activeIndex = 0;
        }
        if (this.localEndRecurrenceDate) {
            this.activeIndex = 1;
        }
    }

    @Emit('setRecurrenceEnd')
    setRecurrenceEndHandler() {
        return this.localEndRecurrenceDate;
    }
}
</script>

<style lang='sass'>
.b-form-recurrence
    .fw-check-box__container.form, .fw-check-box__container.form-light
        font-size: 16px
        flex: none
        border-radius: 10px
        height: 37px
        width: 37px
        background-color: #EEF0F3
        padding: 0
        line-height: 19px
        color: #203f6a
        font-weight: 600
        white-space: nowrap

    .icon-checked
        width: 100%
        border-radius: 10px
        background-color: #F7F8FA

        &__background
            background-color: #E8EBEF
            color: #fff
            border-radius: 50%
            height: 25px
            width: 25px

    .icon-checked__active
        .icon-checked__background
            background-color: $main-green
            color: #fff

    .fw-check-box__wrapper
        margin-bottom: 0

    &__title
        padding: 0 50px
</style>
